/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import {
  fetchOrderTags,
  fetchOrderTypes,
  fetchPurchaseOrderById,
} from '@/api/orders';
import { PurchaseOrderOverviewTab } from '@/app/(client)/orders/-components/PurchaseOrderOverviewTab';
import {
  attachmentTemplatesQueryOptions,
  useAttachmentTemplatesForImport,
} from '@/app/(client)/orders/-hooks/useAttachmentTemplatesForImport';
import {
  buyerCompaniesQueryOptions,
  useBuyerCompaniesDropdown,
} from '@/app/(client)/orders/-hooks/useBuyerCompaniesDropdown';
import { useOrderTags } from '@/app/(client)/orders/-hooks/useOrderTags';
import { useOrderTypes } from '@/app/(client)/orders/-hooks/useOrderTypes';
import {
  purchaseOrderDetailKeys,
  usePurchaseOrderDetail,
} from '@/app/(client)/orders/-hooks/usePurchaseOrderDetail';
import {
  facilityProcessesQueryOptions,
  useFacilityProcesses,
} from '@/hooks/useFacilityProcesses';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/overview',
)({
  loader: ({ params }) =>
    Promise.all([
      queryClient.ensureQueryData({
        queryKey: purchaseOrderDetailKeys.detail(params.poId),
        queryFn: () =>
          fetchPurchaseOrderById(params.poId).then(res => res.data),
      }),
      queryClient.ensureQueryData({
        queryKey: ['cascade-tracing', 'order-tags'],
        queryFn: fetchOrderTags,
      }),
      queryClient.ensureQueryData({
        queryKey: ['cascade-tracing', 'order-types'],
        queryFn: fetchOrderTypes,
      }),
      queryClient.ensureQueryData(buyerCompaniesQueryOptions),
      queryClient.ensureQueryData(attachmentTemplatesQueryOptions),
      queryClient.ensureQueryData(facilityProcessesQueryOptions),
    ]),
  component: PurchaseOrderOverviewRoute,
});

function PurchaseOrderOverviewRoute() {
  const { poId } = Route.useParams();
  const { data: order } = usePurchaseOrderDetail(poId);
  const { data: orderTags } = useOrderTags();
  const { data: orderTypes } = useOrderTypes();
  const { data: buyerCompaniesData } = useBuyerCompaniesDropdown();
  const { data: templatesData } = useAttachmentTemplatesForImport();
  const { processes: fpProcesses } = useFacilityProcesses();

  if (!order) return null;

  return (
    <PurchaseOrderOverviewTab
      order={order}
      orderTags={orderTags ?? []}
      orderTypes={orderTypes ?? []}
      buyerCompanies={buyerCompaniesData?.data ?? []}
      facilityProcessOptions={fpProcesses ?? []}
      attachmentTemplates={templatesData?.data ?? []}
    />
  );
}
